import React, { FC } from 'react';

import Modal from 'components/Modal/index';

interface ModalProps {
  title: string;
  content: string;
  buttons: any;
  onClose: () => any;
}

const MyClocksModal: FC<ModalProps> = ({
  title,
  content,
  buttons,
  onClose
}) => (
  <Modal
    id='my-clocks-modal'
    aria-label='my-clocks-modal'
    title={title}
    contentAbove={content}
    buttons={buttons}
    onClose={onClose}
  />
);

export default MyClocksModal;
